module.exports = __webpack_public_path__ + "images/fec36c517086cc5b4da8c80afb0e34ab.png";